import React, { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Spinner, Alert } from "reactstrap";
import BizinBackend from "../../../../helpers/bizin_helper";
import useGetCsrfToken from "../../../../Hooks/useGetCsrfToken";
import { DF_LO0025Context } from "../context";
import CardFlow from "../../../../components/Common/CardFlow";
import CardContext from "../../../../components/Common/CardContext";

function GridBody({ ID_Tabela_Frete: ID_Tabela_Frete_Prop, onClose } = {}) {
  const ctx = useContext(DF_LO0025Context);
  const ID_Tabela_Frete = ID_Tabela_Frete_Prop ?? ctx?.ID_Tabela_Frete;
  const { access_token } = useSelector((state) => ({
    access_token: state.login.user?.access_token,
  }));
  const csrfToken = useGetCsrfToken();

  const [loading, setLoading] = useState(true);
  const [timeline, setTimeline] = useState([]);
  const [flow, setFlow] = useState([]);
  const [context, setContext] = useState({});
  const [accordionOpen, setAccordionOpen] = useState(true);

  useEffect(() => {
    const carregar = async () => {
      if (!ID_Tabela_Frete || !csrfToken || !access_token) return;
      try {
        const resp = await BizinBackend.executeProcedure(
          { 1: Number(ID_Tabela_Frete) },
          "FRONT_Workspace_DF_LO0020_Historico_Rota",
          csrfToken,
          access_token
        );

        const rs1 = resp?.resultset_1 || (Array.isArray(resp) ? resp[0] : []);
        const rs2 = resp?.resultset_2 || (Array.isArray(resp) ? resp[1] : []);
        const rs3 = resp?.resultset_3 || (Array.isArray(resp) ? resp[2] : []);

        setTimeline(Array.isArray(rs1) ? rs1 : []);
        setFlow(Array.isArray(rs2) ? rs2 : []);
        setContext(Array.isArray(rs3) ? rs3[0] || {} : {});
      } catch (error) {
        console.error("Erro ao carregar histórico:", error);
      } finally {
        setLoading(false);
      }
    };
    carregar();
  }, [ID_Tabela_Frete, csrfToken, access_token]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 200 }}>
        <Spinner className="text-primary" />
      </div>
    );
  }

  const contextData = [
    { label: "Vigência", value: context.Vigencia || "—", largura: "ctx-col-vigencia" },
    { label: "Valor", value: context.Valor || "—", largura: "ctx-col-valor" },
    { label: "Status", value: context.Status_Json || "—", largura: "ctx-col-status" },
  ];

  const corIcone = (cor) => {
    switch (cor) {
      case "success": return "#3B82F6";  // Azul - Ativação
      case "warning": return "#FACC15";  // Amarelo - Inativação
      case "info": return "#3B82F6";     // Azul - Criação/Edição
      default: return "#3B82F6";
    }
  };
  const corLinha = (evento) => {
    const tipo = String(evento.Tipo_Evento || "").trim().toLowerCase();
    return (tipo === "inativação" || tipo === "inativacao" || tipo === "vencimento") ? "#FACC15" : "#3B82F6";
  };

  const formatDate = (data) => {
    if (!data) return "—";
    const dt = new Date(data);
    if (isNaN(dt)) return "—";
    return `${String(dt.getDate()).padStart(2, "0")}/${String(dt.getMonth() + 1).padStart(2, "0")}/${dt.getFullYear()} às ${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`;
  };

  return (
    <div className="historico-rota-container">
      {/* ===== Card Superior: Fluxo + Contexto ===== */}
      <div className="historico-header-card">
        <div className="historico-flow-section">
          <CardFlow flowData={flow} />
        </div>
        <div className="historico-context-section">
          <CardContext data={contextData} isRenderModal />
        </div>
      </div>

      {/* ===== Accordion: Gestão de Fretes ===== */}
      <div className="historico-accordion-wrapper">
        <div
          className={`historico-accordion-header ${accordionOpen ? "open" : ""}`}
          onClick={() => setAccordionOpen(!accordionOpen)}
        >
          <div className="d-flex align-items-center gap-2">
            <i className="fa-solid fa-route text-color-azul1"></i>
            <span className="fw-bold text-color-azul2" style={{ fontSize: "20px" }}>Gestão de Fretes</span>
          </div>
          <i className={`fa-solid ${accordionOpen ? "fa-chevron-up" : "fa-chevron-down"} text-color-azul1`}></i>
        </div>

        {accordionOpen && (
          <div className="historico-accordion-body">
            {/* Timeline */}
            {timeline.length === 0 && (
              <Alert color="info" className="font-size-13 mb-0">
                Nenhum evento registrado além da criação.
              </Alert>
            )}

            <div className="historico-timeline">
              {timeline.map((evento, idx) => {
                const cor = corIcone(evento.Cor_Evento);
                const isLast = idx === timeline.length - 1;

                return (
                  <div key={evento.ID_Log || idx} className="historico-timeline-item">
                    {/* Coluna esquerda: ícone + linha */}
                    <div className="historico-timeline-left">
                      <div
                        className="historico-timeline-icon"
                        style={{ backgroundColor: cor }}
                      >
                        <i className={`${evento.Icone || "fa-solid fa-clock-rotate-left"} text-white`}></i>
                      </div>
                      {!isLast && (
                        <div
                          className="historico-timeline-line"
                          style={{ backgroundColor: corLinha(evento) }}
                        />
                      )}
                    </div>

                    {/* Coluna direita: conteúdo */}
                    <div className="historico-timeline-content">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <div className="d-flex align-items-center gap-2">
                          <h5 className="mb-0 fw-bold text-color-azul1" style={{ fontSize: "20px" }}>
                            {evento.Tipo_Evento}
                          </h5>
                          {evento.Acao === "INS" && (
                            <i className="fa-solid fa-arrow-up-right-from-square font-size-12 text-muted"></i>
                          )}
                        </div>
                      </div>

                      {/* Descrição do evento (ex: vencimento) */}
                      {evento.Descricao_Evento && (
                        <div className="text-muted mb-2" style={{ fontSize: "14px" }}>
                          {evento.Descricao_Evento}
                        </div>
                      )}

                      {/* Tags de Criação: vigência + valores */}
                      {evento.Acao === "INS" && (
                        <div className="d-flex flex-wrap gap-2 mb-2">
                          {(evento.Vigencia_Evento || context.Vigencia) && (
                            <span className="historico-timeline-badge">
                              <i className="fa-solid fa-calendar-days text-color-azul2 me-1"></i>
                              {evento.Vigencia_Evento || context.Vigencia}
                            </span>
                          )}
                          {evento.Valores_JSON && (() => {
                            try {
                              const valores = typeof evento.Valores_JSON === "string"
                                ? JSON.parse(evento.Valores_JSON)
                                : evento.Valores_JSON;
                              return Array.isArray(valores) ? valores.map((v, i) => (
                                <span key={i} className="historico-timeline-badge">
                                  <i className="fa-solid fa-dollar-sign text-color-azul2 me-1"></i>
                                  {v.campo}: {v.valor}
                                </span>
                              )) : null;
                            } catch { return null; }
                          })()}
                        </div>
                      )}

                      {/* Tags de Edição: array de alteracoes */}
                      {evento.Evento === "EDICAO" && evento.Alteracoes_JSON && (() => {
                        try {
                          const alteracoes = typeof evento.Alteracoes_JSON === "string"
                            ? JSON.parse(evento.Alteracoes_JSON)
                            : evento.Alteracoes_JSON;
                          return Array.isArray(alteracoes) && alteracoes.length > 0 ? (
                            <div className="d-flex flex-wrap gap-2 mb-2">
                              {alteracoes.map((alt, i) => {
                                const isVigencia = String(alt.campo || "").toLowerCase() === "vigencia";
                                return (
                                  <span key={i} className="historico-timeline-badge">
                                    <i className={`${isVigencia ? "fa-solid fa-calendar-days" : "fa-solid fa-dollar-sign"} text-color-azul2 me-1`}></i>
                                    {alt.campo}: <s className="text-muted">{alt.anterior}</s>
                                    {" → "}
                                    <strong className="text-color-azul1">{alt.novo}</strong>
                                  </span>
                                );
                              })}
                            </div>
                          ) : null;
                        } catch { return null; }
                      })()}

                      {/* Log: data + autor */}
                      <div className="text-muted" style={{ fontSize: "13px" }}>
                        {formatDate(evento.DataHora)}
                        {evento.Nome_Usuario && evento.Nome_Usuario !== "Sistema" && (
                          <span> por {evento.Nome_Usuario}</span>
                        )}
                        {evento.Email_Usuario && evento.Email_Usuario !== "Sistema" && (
                          <span> ({evento.Email_Usuario})</span>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>

      {/* ===== Botão Voltar ===== */}
      <div className="d-flex justify-content-end mt-3">
        <button
          className="btn fw-semibold btn-cancelar-co0005"
          onClick={() => {
            if (onClose) return onClose();
            if (window.parent !== window) {
              window.parent.postMessage({ type: "closeModal", isReloadPage: false }, "*");
            }
          }}
        >
          Voltar
        </button>
      </div>
    </div>
  );
}

export default GridBody;